import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import type { FC } from 'react';
import { Datepicker } from '../Datepicker/Datepicker';
import { FormField } from '../FormField/FormField';
import type { DatepickerFieldProps } from './DatepickerField.types';

export const DatepickerField: FC<DatepickerFieldProps> = ({
  value = null,
  className,
  error,
  ...props
}) => {
  const datepickerInputId = useHtmlId('datepickerInput');
  return (
    <FormField
      className={className}
      error={error}
      htmlFor={datepickerInputId}
      {...props}
    >
      <Datepicker
        {...props}
        hasError={props.hasError || error !== undefined}
        value={value}
        inputId={datepickerInputId}
      />
    </FormField>
  );
};
